import React, { useState } from "react";
import { ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { Dialog } from "@mui/material";
import { Input } from "@vds/inputs";
import { Icon } from "@vds/icons";
import { Notification } from "@vds/notifications";
import { Checkbox } from "@vds/checkboxes";
import { Loader } from "@vds/loaders";

const ResolveEvents = ({
  showResolveEvents,
  setShowResolveEvents,
  handleResolveIncident,
  loader,
}) => {
  const [resolveNotes, setResolveNotes] = useState("");
  const [isCheckboxSelected, setIsCheckBoxSelected] = useState(true);
  return (
    <Dialog
      aria-label="Resolve event modal"
      fullWidthh={true}
      maxWidth={"md"}
      open={showResolveEvents?.isOpen}
      disableOutsideClick={true}
      surface="light"
    >
      <div style={{ margin: "3% 3% 5% 3%" }}>
        <ModalTitle>
          <Title size="large" bold>
            Resolve event
          </Title>
        </ModalTitle>
        <div
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "25px",
            top: "25px",
          }}
          data-testid="eventsInfo_closeResolveEventsModal"
          onClick={(e) => {
            setShowResolveEvents({ isOpen: false });
          }}
        >
          <Icon name="close" />
        </div>

        <ModalBody>
          <Body size="large">
            <Notification type="warning" hideCloseButton={true} subtitle="">
              <h6>
                Resolving this event will remove it from the alerts list on the
                dashboard.
              </h6>
            </Notification>
          </Body>
          <br />
          <Input
            label="Incident notes"
            defaultValue={resolveNotes}
            onChange={(e) => {
              setResolveNotes(e.target.value);
            }}
            data-testid="eventsInfo_resolveEventsModalInputNotes"
            errorText="Enter incident resolution note"
          />
          <div style={{ marginTop: "2rem" }}>
            <Checkbox
              name={"This event was accurately detected"}
              width="auto"
              disabled={false}
              error={false}
              selected={isCheckboxSelected}
              id="eventsInfo_resolveEventsModalDetectionCheckbox"
              onChange={(e) => {
                setIsCheckBoxSelected(!isCheckboxSelected);
              }}
            >
              This event was accurately detected
            </Checkbox>
          </div>
        </ModalBody>
        <ModalFooter
          buttonData={{
            primary: {
              width: "100%",
              children: "Resolve",
              disabled: !resolveNotes?.trim(),
              "data-testid":"eventsInfo_resolveEventsModalPrimaryButton",
              onClick: () => {
                handleResolveIncident(resolveNotes, isCheckboxSelected);
              },
            },
          }}
        />
      </div>
      {loader ? <Loader active={loader} fullscreen={false} /> : ""}
    </Dialog>
  );
};

export default ResolveEvents;
